import PoliticalParty from './PoliticalParty';

export default PoliticalParty;